import { useCoverageTypeQuery, useGetChannelTypeQuery, useGetCompanyNumberTypeQuery, useGetContactNumberTypeQuery, useGetGroupClassificationQuery, useGetStatusProposalTypeQuery, useModeOfPaymentQuery, usePaymentTermQuery, usePrototypeTypeQuery, useTypeOfGroupQuery, useTypeOfProductQuery, useTypeOfProposalQuery } from "../../../api/gms/group-category/group-category-api";
import { useGetReportingHeadQuery } from "../../../api/it/account/account-api";
import { getErrorMessage } from "../../../utils/get-error-message.utils";
import { useGetDepartmentTypeQuery, useGetLocationTypeQuery, useGetRoleTypeQuery } from "../../../api/it/account-category/account-category-api";

interface UseQueriesOptions {
    isGetRequestAmendments?: boolean;
    page?: number;
    per_page?: number;
    email?: string;
    group_name?: string;
    product?: string;
    preparedBy?: string;
    status?: string;
}

export const useQueries = ({ isGetRequestAmendments, page = 1, per_page = 20, group_name, email, preparedBy, product, status }: UseQueriesOptions = {}) => {

    const { data: channelType, isLoading: isLoadingChannelType, isError: isErrorChannelType, error: errorChannelType, refetch: refetchChannelType, isFetching: isFetchingChannelType } = useGetChannelTypeQuery();
    const errorMessageChannelType = getErrorMessage(errorChannelType)

    const { data: statusProposalType, isLoading: isLoadingStatusProposalType, isError: isErrorStatusProposalType, error: errorStatusProposalType, refetch: refetchStatusProposalType, isFetching: isFetchingStatusProposalType } = useGetStatusProposalTypeQuery();
    const errorMessageStatusProposalType = getErrorMessage(errorStatusProposalType)

    const { data: groupClassification, isLoading: isLoadingGroupClassification, isError: isErrorGroupClassification, error: errorGroupClassification, refetch: refetchGroupClassification, isFetching: isFetchingGroupClassification } = useGetGroupClassificationQuery();
    const errorMessageGroupClassification = getErrorMessage(errorGroupClassification)

    const { data: typeOfGroup, isLoading: isLoadingTypeOfGroup, isError: isErrorTypeOfGroup, error: errorTypeOfGroup, refetch: refetchTypeOfGroup, isFetching: isFetchingTypeOfGroup } = useTypeOfGroupQuery();
    const errorMessageTypeOfGroup = getErrorMessage(errorTypeOfGroup)

    const { data: modeOfPayment, isLoading: isLoadingModeOfPayment, isError: isErrorModeOfPayment, error: errorModeOfPayment, refetch: refetchModeOfPayment, isFetching: isFetchingModeOfPayment } = useModeOfPaymentQuery();
    const errorMessageModeOfPayment = getErrorMessage(errorModeOfPayment)

    const { data: typeOfProposal, isLoading: isLoadingTypeOfProposal, isError: isErrorTypeOfProposal, error: errorTypeOfProposal, refetch: refetchTypeOfProposal, isFetching: isFetchingTypeOfProposal } = useTypeOfProposalQuery();
    const errorMessageTypeOfProposal = getErrorMessage(errorTypeOfProposal)

    const { data: typeOfProduct, isLoading: isLoadingTypeOfProduct, isError: isErrorTypeOfProduct, error: errorTypeOfProduct, refetch: refetchTypeOfProduct, isFetching: isFetchingTypeOfProduct } = useTypeOfProductQuery();
    const errorMessageTypeOfProduct = getErrorMessage(errorTypeOfProduct)

    const { data: prototypeListData, isLoading: isLoadingPrototypeListData, isError: isErrorPrototypeListData, error: errorPrototypeListData, refetch: refetchPrototypeListData, isFetching: isFetchingPrototypeListData } = usePrototypeTypeQuery();
    const errorMessagePrototypeListData = getErrorMessage(errorPrototypeListData)

    const { data: coverageTypeData, isLoading: isLoadingCoverageTypeData, isError: isErrorCoverageTypeData, error: errorCoverageTypeData, refetch: refetchCoverageTypeData, isFetching: isFetchingCoverageTypeData } = useCoverageTypeQuery();
    const errorMessageCoverageTypeData = getErrorMessage(errorCoverageTypeData)

    const { data: paymentTerm, isLoading: isLoadingPaymentTerm, isError: isErrorPaymentTerm, error: errorPaymentTerm, refetch: refetchPaymentTerm, isFetching: isFetchingPaymentTerm } = usePaymentTermQuery();
    const errorMessagePaymentTerm = getErrorMessage(errorPaymentTerm)

    const { data: typeOfCompanyNumber, error: errorTypeOfCompanyNumber, isError: isErrorTypeOfCompanyNumber, isLoading: isLoadingTypeOfCompanyNumber, refetch: refetchTypeOfCompanyNumber, isFetching: isFetchingTypeOfCompanyNumber } = useGetCompanyNumberTypeQuery();
    const errorMessageTypeOfCompanyNumber = getErrorMessage(errorTypeOfCompanyNumber)

    const { data: typeOfContactNumber, error: errorTypeOfContactNumber, isError: isErrorTypeOfContactNumber, isLoading: isLoadingTypeOfContactNumber, refetch: refetchTypeOfContactNumber, isFetching: isFetchingTypeOfContactNumber } = useGetContactNumberTypeQuery();
    const errorMessageTypeOfContactNumber = getErrorMessage(errorTypeOfContactNumber)

    // const { data: getExtensionProposalRequest, isLoading: isLoadingGetExtensionProposalRequest, isError: isErrorGetExtensionProposalRequest, error: errorGetExtensionProposalRequest, refetch: refetchGetExtensionProposalRequest, isFetching: isFetchingGetExtensionProposalRequest } = useGetAllRequestExtensionQuery({ page, per_page, group_name, email, preparedBy, product, status });
    // const errorMessageGetExtensionProposalRequest = getErrorMessage(errorGetExtensionProposalRequest)

    // const { data: getUserList, isLoading: isLoadingGetUserList, isError: isErrorGetUserList, error: errorGetUserList, refetch: refetchGetUserList, isFetching: isFetchingGetUserList } = useGetUserListQuery();
    // const errorMessageGetUserList = getErrorMessage(errorGetUserList)

    const { data: department, error: errorDepartment, isError: isErrorDepartment, isLoading: isLoadingDepartment, refetch: refetchDepartment, isFetching: isFetchingDepartment } = useGetDepartmentTypeQuery();
    const errorMessageDepartment = getErrorMessage(errorDepartment)

    const { data: location, error: errorLocation, isError: isErrorLocation, isLoading: isLoadingLocation, refetch: refetchLocation, isFetching: isFetchingLocation } = useGetLocationTypeQuery();
    const errorMessageLocation = getErrorMessage(errorLocation)

    const { data: role, error: errorRole, isError: isErrorRole, isLoading: isLoadingRole, refetch: refetchRole, isFetching: isFetchingRole } = useGetRoleTypeQuery();
    const errorMessageRole = getErrorMessage(errorRole)

    const { data: reportingHead, error: errorReportingHead, isError: isErrorReportingHead, isLoading: isLoadingReportingHead, refetch: refetchReportingHead, isFetching: isFetchingReportingHead } = useGetReportingHeadQuery();
    const errorMessageReportingHead = getErrorMessage(errorReportingHead)

    // const { data: getProposal, error: errorGetProposal, isError: isErrorGetProposal, isLoading: isLoadingGetProposal, refetch: refetchGetProposal, isFetching: isFetchingGetProposal } = useGetProposalQuery({ page, per_page, group_name, email, preparedBy, product, status });
    // const errorMessageGetProposal = getErrorMessage(errorGetProposal)

    // const { data: getRequestAmendments, error: errorGetRequestAmendments, isError: isErrorGetRequestAmendments, isLoading: isLoadingGetRequestAmendments, refetch: refetchGetRequestAmendments, isFetching: isFetchingGetRequestAmendments } = useGetRequestAmendmentsQuery({ page, per_page, group_name, email, preparedBy, product, status }, { refetchOnMountOrArgChange: true, });
    // const errorMessageGetRequestAmendments = getErrorMessage(errorGetRequestAmendments)

    // const productType = useSelector(selectProductTypeState);
    // const basicPlanType = useSelector(selectBasicPlansState);
    // const products = typeOfProduct?.find((p: any) => p.product_id === productType?.id);
    // const basicPlansData = products?.basic_plans;
    // const selectedBasicPlan = basicPlansData?.find((plan) => plan.basic_plan_id === basicPlanType?.id);

    return {
        channelType,
        isLoadingChannelType,
        isErrorChannelType,
        errorChannelType,
        refetchChannelType,
        isFetchingChannelType,
        errorMessageChannelType,

        statusProposalType,
        isLoadingStatusProposalType,
        isErrorStatusProposalType,
        errorStatusProposalType,
        refetchStatusProposalType,
        isFetchingStatusProposalType,
        errorMessageStatusProposalType,

        groupClassification,
        isLoadingGroupClassification,
        isErrorGroupClassification,
        errorGroupClassification,
        refetchGroupClassification,
        isFetchingGroupClassification,
        errorMessageGroupClassification,

        typeOfGroup,
        isLoadingTypeOfGroup,
        isErrorTypeOfGroup,
        errorTypeOfGroup,
        refetchTypeOfGroup,
        isFetchingTypeOfGroup,
        errorMessageTypeOfGroup,

        modeOfPayment,
        isLoadingModeOfPayment,
        isErrorModeOfPayment,
        errorModeOfPayment,
        refetchModeOfPayment,
        isFetchingModeOfPayment,
        errorMessageModeOfPayment,

        typeOfProposal,
        isLoadingTypeOfProposal,
        isErrorTypeOfProposal,
        errorTypeOfProposal,
        refetchTypeOfProposal,
        isFetchingTypeOfProposal,
        errorMessageTypeOfProposal,

        typeOfProduct,
        isLoadingTypeOfProduct,
        isErrorTypeOfProduct,
        errorTypeOfProduct,
        refetchTypeOfProduct,
        isFetchingTypeOfProduct,
        errorMessageTypeOfProduct,

        prototypeListData,
        isLoadingPrototypeListData,
        isErrorPrototypeListData,
        errorPrototypeListData,
        refetchPrototypeListData,
        isFetchingPrototypeListData,
        errorMessagePrototypeListData,

        coverageTypeData,
        isLoadingCoverageTypeData,
        isErrorCoverageTypeData,
        errorCoverageTypeData,
        refetchCoverageTypeData,
        isFetchingCoverageTypeData,
        errorMessageCoverageTypeData,

        paymentTerm,
        isLoadingPaymentTerm,
        isErrorPaymentTerm,
        errorPaymentTerm,
        refetchPaymentTerm,
        isFetchingPaymentTerm,
        errorMessagePaymentTerm,

        // getUserList,
        // isLoadingGetUserList,
        // isErrorGetUserList,
        // errorGetUserList,
        // refetchGetUserList,
        // isFetchingGetUserList,
        // errorMessageGetUserList,

        // getExtensionProposalRequest,
        // isLoadingGetExtensionProposalRequest,
        // isErrorGetExtensionProposalRequest,
        // errorGetExtensionProposalRequest,
        // refetchGetExtensionProposalRequest,
        // isFetchingGetExtensionProposalRequest,
        // errorMessageGetExtensionProposalRequest,

        // getProposal,
        // isLoadingGetProposal,
        // isErrorGetProposal,
        // errorGetProposal,
        // refetchGetProposal,
        // isFetchingGetProposal,
        // errorMessageGetProposal,

        department,
        isLoadingDepartment,
        isErrorDepartment,
        errorDepartment,
        refetchDepartment,
        isFetchingDepartment,
        errorMessageDepartment,

        location,
        isLoadingLocation,
        isErrorLocation,
        errorLocation,
        refetchLocation,
        isFetchingLocation,
        errorMessageLocation,

        role,
        isLoadingRole,
        isErrorRole,
        errorRole,
        refetchRole,
        isFetchingRole,
        errorMessageRole,

        reportingHead,
        isLoadingReportingHead,
        isErrorReportingHead,
        errorReportingHead,
        refetchReportingHead,
        isFetchingReportingHead,
        errorMessageReportingHead,

        // getRequestAmendments,
        // isLoadingGetRequestAmendments,
        // isErrorGetRequestAmendments,
        // errorGetRequestAmendments,
        // refetchGetRequestAmendments,
        // isFetchingGetRequestAmendments,
        // errorMessageGetRequestAmendments,

        typeOfCompanyNumber,
        isLoadingTypeOfCompanyNumber,
        isErrorTypeOfCompanyNumber,
        errorTypeOfCompanyNumber,
        refetchTypeOfCompanyNumber,
        isFetchingTypeOfCompanyNumber,
        errorMessageTypeOfCompanyNumber,

        typeOfContactNumber,
        isLoadingTypeOfContactNumber,
        isErrorTypeOfContactNumber,
        errorTypeOfContactNumber,
        refetchTypeOfContactNumber,
        isFetchingTypeOfContactNumber,
        errorMessageTypeOfContactNumber,
    }
}